var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChoosePlanCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6644 0.752601C14.0771 1.11952 14.1143 1.75159 13.7474 2.16437L5.74741 11.1644C5.56444 11.3702 5.30467 11.4915 5.02937 11.4996C4.75408 11.5077 4.48764 11.4019 4.29289 11.2071L0.292893 7.20712C-0.0976311 6.81659 -0.0976311 6.18343 0.292893 5.7929C0.683417 5.40238 1.31658 5.40238 1.70711 5.7929L4.95718 9.04298L12.2526 0.835647C12.6195 0.422864 13.2516 0.385683 13.6644 0.752601Z",
    fill: "#33CC98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoosePlanCheck);
export default __webpack_public_path__ + "static/media/choose-plan-check.dd73887c29587773396f1883e321de16.svg";
export { ForwardRef as ReactComponent };